import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes";
import "./globals.css";

// In production builds, force the canonical origin from VITE_APP_URL. Guards
// against landing on a non-TLS / non-standard-port leak of the same host
// (e.g. http://ws-dev.wisdomise-world.link:3000) — every relative redirect
// after sign-in would otherwise inherit the wrong scheme/port.
if (import.meta.env.PROD && import.meta.env.VITE_APP_URL) {
  const canonicalOrigin = new URL(import.meta.env.VITE_APP_URL).origin;
  if (window.location.origin !== canonicalOrigin) {
    window.location.replace(
      canonicalOrigin +
        window.location.pathname +
        window.location.search +
        window.location.hash,
    );
  }
}

// LocatorJS: Option/Alt + click any component to jump to its source code (dev only)
import setupLocatorUI from "@locator/runtime";
if (import.meta.env.DEV) {
  setupLocatorUI({ showIntro: true });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
